import { redirect, type RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { cardsLoader } from './cards-loader';

export const cardsRoutes: RouteObject = {
  loader: cardsLoader,
  children: [
    {
      path: '/admin/cards',
      lazy: lazyComponent(() => import('@pages/tenant/cards'), 'CardsPage'),
      children: [
        { index: true, loader: () => redirect('/admin/cards/issued') },
        {
          path: 'issued',
          lazy: lazyComponent(() => import('@pages/tenant/cards'), 'IssuedCardsPage'),
        },
        {
          path: 'unissued',
          lazy: lazyComponent(() => import('@pages/tenant/cards'), 'UnissuedCardsPage'),
        },
      ],
    },
    {
      path: '/admin/cards/:id',
      lazy: lazyComponent(() => import('@pages/tenant/cards'), 'CardDetailsPage'),
    },
  ],
};
